import React from "react"
import ReactDOM from "react-dom"
import NavigationalCardContainer from "./navigational-card-container"

export default class NavigationalCardContainerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<NavigationalCardContainer {...self.modelJson} />, self.elem)
  }
}
